import React, { useState } from "react";
import { Row, Col, Nav, Modal, Button, Form, Alert } from "react-bootstrap";

import useActiveLink from "../../components/useActiveLink";
import { fetchEventCode } from "../../lib/api";

const Footer = () => {
  const { activeLink, handleLinkClick } = useActiveLink(
    ".navbar-nav li.active"
  );

  const [showModal, setShowModal] = useState(false);
  const [eventCode, setEventCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInviteeClick = () => {
    setShowModal(true);
    setEventCode("");
    setError("");
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEventCode("");
    setError("");
    setIsLoading(false);
  };

  const handleEventCodeSubmit = async (
    e: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    e.preventDefault();

    if (!eventCode.trim()) {
      setError("Please enter an event code.");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response: any = await fetchEventCode(eventCode.trim());
      if (response.status === 200) {
        window.location.href = response.data.guest_book_url;
      }
    } catch (error) {
      const errorResponse: any = error;
      const errorStatus = errorResponse?.response?.status;
      if (errorStatus === 404) {
        setError("Invalid event code. Please check and try again.");
      } else {
        setError(
          "An error occurred while verifying the event code. Please try again."
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <footer className="section blog-bg-footer pb-5">
        <div className="container">
          <Row>
            <Col lg={12}>
              <Row>
                <Col lg={2}>
                  <div>
                    <h6 className="footer-heading text-uppercase fw-bold f-13">
                      quick links
                    </h6>
                    <ul className="list-unstyled footer-link mt-3 mb-0">
                      <li
                        className={`nav-item ${
                          activeLink === "/home" ? "active" : ""
                        }`}
                      >
                        <Nav.Link
                          href="#home"
                          onClick={() => handleLinkClick("/home")}
                        >
                          Home
                        </Nav.Link>
                      </li>
                      <li
                        className={`nav-item ${
                          activeLink === "/services" ? "active" : ""
                        }`}
                      >
                        <Nav.Link
                          href="#events"
                          onClick={() => handleLinkClick("/services")}
                        >
                          Event
                        </Nav.Link>
                      </li>
                      <li
                        className={`nav-item ${
                          activeLink === "/pricing" ? "active" : ""
                        }`}
                      >
                        <Nav.Link
                          href="#packages"
                          onClick={() => handleLinkClick("/pricing")}
                        >
                          Packages
                        </Nav.Link>
                      </li>
                      <li
                        className={`nav-item ${
                          activeLink === "/howto" ? "active" : ""
                        }`}
                      >
                        <Nav.Link
                          href="#howto"
                          onClick={() => handleLinkClick("/howto")}
                        >
                          How to Use
                        </Nav.Link>
                      </li>
                      <li
                        className={`nav-item ${
                          activeLink === "/Aboutus" ? "active" : ""
                        }`}
                      >
                        <Nav.Link
                          href="#aboutus"
                          onClick={() => handleLinkClick("/aboutus")}
                        >
                          About Us
                        </Nav.Link>
                      </li>
                      <li
                        className={`nav-item ${
                          activeLink === "/contact" ? "active" : ""
                        }`}
                      >
                        <Nav.Link
                          href="#contactus"
                          onClick={() => handleLinkClick("/contact")}
                        >
                          Contact Us
                        </Nav.Link>
                      </li>
                    </ul>
                  </div>
                </Col>

                <Col lg={2}>
                  <div>
                    <h6 className="footer-heading text-uppercase fw-bold f-13">
                      login
                    </h6>
                    <ul className="list-unstyled footer-link mt-3 mb-0">
                      <li>
                        <Nav.Link href="https://app.theendlessmoment.com">
                          Host Login
                        </Nav.Link>
                      </li>
                      <li
                        className={`nav-item ${
                          activeLink === "/login" ? "active" : ""
                        }`}
                      >
                        <Nav.Link
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleInviteeClick();
                          }}
                        >
                          Invitees Login
                        </Nav.Link>
                      </li>
                    </ul>
                  </div>
                </Col>

                <Col lg={2}>
                  <div>
                    <h6 className="footer-heading text-uppercase fw-bold f-13">
                      events
                    </h6>
                    <ul className="list-unstyled footer-link mt-3 mb-0">
                      <li>
                        <Nav.Link
                          href="#events"
                          onClick={() => handleLinkClick("/services")}
                        >
                          Wedding
                        </Nav.Link>
                      </li>
                      <li>
                        <Nav.Link
                          href="#events"
                          onClick={() => handleLinkClick("/services")}
                        >
                          Parties
                        </Nav.Link>
                      </li>
                      <li>
                        <Nav.Link
                          href="#events"
                          onClick={() => handleLinkClick("/services")}
                        >
                          Corporate Events
                        </Nav.Link>
                      </li>
                    </ul>
                  </div>
                </Col>

                <Col lg={2}>
                  <div>
                    <h6 className="footer-heading text-uppercase fw-bold f-13">
                      socials
                    </h6>
                    <ul className="list-unstyled footer-link mt-3 mb-0">
                      <li>
                        <Nav.Link
                          href="https://www.instagram.com/theendlessmoment"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Instagram
                        </Nav.Link>
                      </li>
                      <li>
                        <Nav.Link
                          href="https://www.facebook.com/theendlessmoment"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Facebook
                        </Nav.Link>
                      </li>
                      <li>
                        <Nav.Link
                          href="https://www.tiktok.com/@the_endless_moment"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          TikTok
                        </Nav.Link>
                      </li>
                    </ul>
                  </div>
                </Col>

                <Col lg={2}>
                  <div>
                    <h6 className="footer-heading text-uppercase fw-bold f-13">
                      policies
                    </h6>
                    <ul className="list-unstyled footer-link mt-3 mb-0">
                      <li>
                        <Nav.Link href="/term-and-conditions">
                          Terms and Conditions
                        </Nav.Link>
                      </li>
                      <li>
                        <Nav.Link href="/privacy-policy">
                          Privacy Policies
                        </Nav.Link>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col lg={12}>
                  <div className="agency-footer-alt-content">
                    <p className="copy-right text-left mb-0">
                      © {new Date().getFullYear()} The Endless Moment. All
                      rights reserved.
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={4}></Col>
          </Row>
        </div>
      </footer>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Enter Event Code</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleEventCodeSubmit}>
          <Modal.Body>
            {error && (
              <Alert variant="danger" className="mb-3">
                {error}
              </Alert>
            )}
            <Form.Group className="mb-3">
              <Form.Label>Event Code</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your event code"
                value={eventCode}
                onChange={(e) => setEventCode(e.target.value)}
                disabled={isLoading}
                autoFocus
              />
              <Form.Text className="text-muted py-5 mt-2">
                <br />
                Please enter the unique event code provided by your host.
                <br />
                <br />
                Hosts can find this code under Guestbook in their settings —
                it’s the part right after id= in the link.
              </Form.Text>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn-md"
              variant="secondary"
              onClick={handleCloseModal}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <button
              className="btn btn-md btn-custom"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Continue"}
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Footer;
